<template>
  <div>
    <!-- 幣種選單（目前只有 EUR） -->
    <div class="crypto-select-frame">
      <div class="colu-12 for-label">
        {{ $t('Bao.currency') }}
      </div>
      <div class="lang-select">
        <button class="btn-select" value="EUR" @click="isCurrencyOpen = !isCurrencyOpen">
          <li><span>EUR</span></li>
        </button>
        <div :class="['b', { active: isCurrencyOpen }]">
          <ul class="crypto-list">
            <li @click="isCurrencyOpen = false">
              <span>EUR</span>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <!-- 匯率 + 金額輸入區 -->
    <div :class="isMobile ? 'exchange-rate-frame' : 'ch-crypto-form'">
      <div :class="isMobile ? '' : 'input-amount-group'">
        <div class="form-input-n input-frame input-dep-amount-frame">
          <div v-if="!isMobile" class="input-title">
            {{ $t('Bao.amount') }}
          </div>
          <div class="input-amount">
            <input
              :value="cryptoAmount"
              class="input-amount-content"
              placeholder="0"
              type="text"
              @input="$emit('crypto-input', $event)"
            >
            <span class="currency">JPY</span>
          </div>
        </div>
      </div>
      <!-- 匯率顯示 -->
      <div class="crypto">
        <div :class="isMobile ? 'exchange-rate-box-n' : 'crypto-infor'">
          <div :class="isMobile ? 'exchange-rate h5-type' : 'exchange-rate-box-n'">
            <div :class="{ 'exchange-rate': !isMobile }">
              <div v-if="!timeLeft">
                <span class="currencyA">{{ $t('Bao.current_rate') }}:</span>
                <span class="currencyB">{{ $t('Bao.expired_rate', { crypto: 'EUR€' }) }}</span>
              </div>
              <div v-if="timeLeft > 0">
                <span class="currencyA">{{ isMobile ? '' : ' ' }}1EUR€{{ isMobile ? '' : ' ' }}</span>
                =
                <span class="currencyB">{{ isMobile ? '' : ' ' }}{{ currencyRate.deposit_rate }}JPY</span>
              </div>
              <div v-if="timeLeft > 0">
                <span class="currencyB">{{ isMobile ? '' : ' ' }}{{ cryptoAmount }}EUR€{{ isMobile ? '' : ' ' }}</span>
                =
                <span class="currencyA">{{ isMobile ? '' : ' ' }}{{ currencyRate.currencyRate }}JPY</span>
              </div>
            </div>
          </div>
        </div>

        <!-- 倒數 + 重整按鈕 -->
        <div
          class="recheck-bn"
          @click="timeLeft <= 0 ? $emit('recheck', paymentId) : null"
        >
          <div v-if="timeLeft > 0" class="countdown-box">
            {{ formattedTime }}
          </div>
          <div v-else class="btn-lock-check">
            {{ $t('Bao.refresh_rate') }}
          </div>
        </div>
      </div>
    </div>

    <!-- Jeton Cash 卡片欄位 -->
    <form :class="isMobile ? 'dep-form-frame' : 'row-frame dep-form-frame colu-12 ml-0 gx-3 form-row-gap'">
      <div class="colu colu-12">
        <label class="colu-12 for-label" :for="`jeton-voucher-${uid}`">
          {{ $t('Bao.jeton_label') }}
        </label>
        <input
          :id="`jeton-voucher-${uid}`"
          :value="jcash.voucherNumber"
          class="for-input inpType"
          type="text"
          :placeholder="$t('Bao.jeton_voucher')"
          :maxlength="isMobile ? undefined : 19"
          @input="
            $emit('update:jcash', { ...jcash, voucherNumber: $event.target.value });
            $emit('check-jeton-voucher', $event.target.value)
          "
        >
        <div v-for="error in jetonVoucherErrors" :key="error" class="input-feedback text-align-R">
          {{ error }}
        </div>
      </div>

      <div :class="isMobile ? 'colu colu-12 flex-colu' : 'colu colu-6 flex-colu'">
        <label class="colu-12 for-label" :for="`jcash-exp-${uid}`">
          {{ $t('Bao.expiration_date') }}
        </label>
        <input
          :id="`jcash-exp-${uid}`"
          :value="jcash.expirationDate"
          maxlength="5"
          class="for-input inpType"
          type="text"
          :placeholder="$t('Bao.expiration_date_placeholder')"
          @input="
            $emit('update:jcash', { ...jcash, expirationDate: $event.target.value });
            $emit('format-jcash-exp', $event)
          "
        >
        <div v-for="error in jcashExpirationDateErrors" :key="error" class="input-feedback text-align-R">
          {{ error }}
        </div>
      </div>

      <div :class="isMobile ? 'colu colu-12 flex-colu' : 'colu colu-6 flex-colu'">
        <label class="colu-12 for-label" :for="`jcash-cvv-${uid}`">
          {{ $t('Bao.security_code') }}
        </label>
        <input
          :id="`jcash-cvv-${uid}`"
          :value="jcash.securityCode"
          class="for-input inpType"
          type="text"
          :placeholder="$t('Bao.security_code_placeholder')"
          maxlength="4"
          @input="
            $emit('update:jcash', { ...jcash, securityCode: $event.target.value });
            $emit('format-jcash-cvv', $event)
          "
        >
        <div v-for="error in jcashSecurityCodeErrors" :key="error" class="input-feedback text-align-R">
          {{ error }}
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: 'DepositUseJetonCashs',
  inject: ['$validator'],
  props: {
    /** 渠道 typeCode，決定顯示哪組欄位 */
    typeCode: {
      type: String,
      default: ''
    },
    /** 渠道 payment_id，給 recheck emit 用 */
    paymentId: {
      type: [Number, String],
      default: null
    },
    /** JetonCash 欄位資料 */
    jcash: {
      type: Object,
      default: () => ({ voucherNumber: '', expirationDate: '', securityCode: '', currency: 'EUR' })
    },
    /** 加密幣金額（JetonCash 用） */
    cryptoAmount: {
      type: [String, Number],
      default: ''
    },
    /** 匯率資料 { deposit_rate, currencyRate } */
    currencyRate: {
      type: Object,
      default: () => ({ deposit_rate: 0, currencyRate: 0 })
    },
    /** 倒數秒數 */
    timeLeft: {
      type: Number,
      default: 0
    },
    /** 格式化後的倒數時間字串，如 "04:59" */
    formattedTime: {
      type: String,
      default: '00:00'
    },
    /** 錯誤陣列 */
    jetonVoucherErrors: { type: Array, default: () => [] },
    jcashExpirationDateErrors: { type: Array, default: () => [] },
    jcashSecurityCodeErrors: { type: Array, default: () => [] },
    /** Mobile 版 */
    isMobile: {
      type: Boolean,
      default: false
    },
    /**
     * 避免 Mobile / PC 同頁面時 label for 和 input id 重複。
     * 傳入 'mb' 或 'pc'。
     */
    uid: {
      type: String,
      default: 'pc'
    }
  },
  data() {
    return {
      isCurrencyOpen: false
    }
  }
}
</script>
